import React from 'react';
import ReactDOM from 'react-dom/client';

import "./assets/scss/themes.scss";
import "./index.css";

import reportWebVitals from './reportWebVitals';

import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";

import { CommerceProvider } from './commerce/CommerceContext';
import { initErrorReporting } from './commerce/errorReporting';

// Pages
import LoopCoffee from './pages/loop-coffee';
import Checkout from './pages/checkout';
import PaymentReturn from './pages/checkout/PaymentReturn';
import PolicyPage from './pages/policies';
import { POLICIES } from './pages/policies/content';

// Starts downloading the SDK chunk (only when runtime-config.js names a DSN) while the page renders.
initErrorReporting();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <CommerceProvider>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LoopCoffee />} />
                <Route path="/home" element={<LoopCoffee />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/checkout/retorno" element={<PaymentReturn />} />
                {POLICIES.map((policy) => (
                    <Route key={policy.path} path={policy.path} element={<PolicyPage policy={policy} />} />
                ))}
            </Routes>
        </BrowserRouter>
    </CommerceProvider>
);

// Performance monitoring
reportWebVitals();
